import { render, staticRenderFns } from "./PlansView.vue?vue&type=template&id=285a9dfe&"
import script from "./PlansView.vue?vue&type=script&lang=js&"
export * from "./PlansView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports